var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 6,
    height: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18293 3C9.5835 3.00221 10.5857 3.0119 11.6506 3.05455L12.0281 3.07101C13.1003 3.12177 14.1715 3.20849 14.7028 3.35663C15.4115 3.55571 15.9685 4.13663 16.1567 4.87299C16.4565 6.04231 16.494 8.32455 16.4986 8.87685L16.4993 8.9913V8.99932C16.4993 8.99932 16.4993 9.0021 16.4993 9.00743L16.4986 9.12188C16.494 9.67418 16.4565 11.9564 16.1567 13.1257C15.9658 13.8648 15.4088 14.4458 14.7028 14.6421C14.1715 14.7902 13.1003 14.8769 12.0281 14.9277L11.6506 14.9441C10.5857 14.9868 9.5835 14.9965 9.18293 14.9987L9.00712 14.9993H8.99932C8.99932 14.9993 8.9967 14.9993 8.99152 14.9993L8.81588 14.9987C7.96808 14.9941 4.42329 14.9558 3.29588 14.6421C2.5872 14.443 2.03019 13.8621 1.8419 13.1257C1.54215 11.9564 1.50468 9.67418 1.5 9.12188V8.87685C1.50468 8.32455 1.54215 6.04231 1.8419 4.87299C2.0328 4.1339 2.58981 3.55299 3.29588 3.35663C4.42329 3.04292 7.96808 3.00466 8.81588 3H9.18293ZM7.49933 6.37435V11.6243L11.9993 8.99932L7.49933 6.37435Z",
    fill: "#E53232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePlay);
export default __webpack_public_path__ + "static/media/youtubePlay.3aee25f65170724c6bdf175ac126cd88.svg";
export { ForwardRef as ReactComponent };